// extracted by mini-css-extract-plugin
module.exports = {"countdownTimer":"CountdownTimer_countdownTimer__yvk53","timeContainer":"CountdownTimer_timeContainer__LtpXA","timeLeft":"CountdownTimer_timeLeft__hWU4M"};